import styled from 'foundations-theming/utils';
import { css } from 'styled-components';
import { OLAF, BATTLESHIP, CALYPSO, GYPSUM, KOALA, OZ_DARK, CANDY_APPLE, CALYPSO_DARK, MARIGOLD_DARK } from 'HubStyleTokens/colors';
import { ROOT_FONT_SIZE, MICROCOPY_SIZE } from 'HubStyleTokens/sizes';
import H5 from 'UIComponents/elements/headings/H5';
import Small from 'UIComponents/elements/Small';
import { rgba } from 'UIComponents/core/Color';
import UIClickable from 'UIComponents/button/UIClickable';
import ActionIcon from 'automation-ui-flow-core/canvas/ActionIcon';
import { withTransientStyleProps } from 'automation-ui-core/components/TransientStylePropsDecorator';
const CARD_SHADOW_OPACITY = 0.4;
const REM_SIZE = parseInt(ROOT_FONT_SIZE, 10);
const CONTENT_OVERHANG_SIZE = Math.round(1.125 * REM_SIZE);
const borderColorMap = {
  success: OZ_DARK,
  danger: CANDY_APPLE,
  selected: CALYPSO_DARK,
  warning: MARIGOLD_DARK
};
const COMMON_CARD_STYLE = css(["display:flex;flex-direction:column;border:1px solid ", ";border-radius:4px;width:", "px;height:", "px;zoom:", ";cursor:pointer;overflow:hidden;&.clickable:hover,&.selected,&.selected.disabled,&.selected.disabled:hover{border-color:", ";outline:1px solid ", ";}&.selected{box-shadow:0 0 6px 1px ", ";}&.disabled,&.disabled:hover{background-color:", ";border-color:", ";outline:none;}&.customBorder{", ";border-width:4px;}"], BATTLESHIP, ({
  $width,
  $scale
}) => $width / $scale, ({
  $height,
  $scale
}) => $height / $scale, ({
  $scale
}) => $scale, CALYPSO, CALYPSO, rgba(CALYPSO, CARD_SHADOW_OPACITY), GYPSUM, BATTLESHIP, ({
  $borderStyle
}) => $borderStyle && `border-color: ${borderColorMap[$borderStyle]}`);
export const StyledActionCard = styled(withTransientStyleProps(UIClickable)).withConfig({
  displayName: "AutomationBuilderCardStyles__StyledActionCard",
  componentId: "sc-1ejxrrh-0"
})(["", " background-color:", ";"], COMMON_CARD_STYLE, ({
  theme
}) => theme.color['do-not-use-olaf']);
export const StyledZoomedOutActionCard = styled(withTransientStyleProps(UIClickable)).withConfig({
  displayName: "AutomationBuilderCardStyles__StyledZoomedOutActionCard",
  componentId: "sc-1ejxrrh-1"
})(["", " background-color:", ";justify-content:space-between;"], COMMON_CARD_STYLE, ({
  $backgroundColor
}) => $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : OLAF);
const COMMON_HEADER_STYLE = css(["display:flex;align-items:stretch;padding:12px 16px ", ";border-top:6px solid ", ";"], ({
  $showIcon
}) => $showIcon ? '' : '4px', ({
  $accentColor
}) => $accentColor || 'transparent');
export const StyledActionCardHeader = styled.div.withConfig({
  displayName: "AutomationBuilderCardStyles__StyledActionCardHeader",
  componentId: "sc-1ejxrrh-2"
})(["", " flex:none;"], COMMON_HEADER_STYLE);
export const StyledZoomedOutActionCardHeader = styled.div.withConfig({
  displayName: "AutomationBuilderCardStyles__StyledZoomedOutActionCardHeader",
  componentId: "sc-1ejxrrh-3"
})(["", " padding:12px;overflow:hidden;"], COMMON_HEADER_STYLE);
export const StyledActionTitle = styled(H5).withConfig({
  displayName: "AutomationBuilderCardStyles__StyledActionTitle",
  componentId: "sc-1ejxrrh-4"
})(["font-size:", ";"], MICROCOPY_SIZE);
export const StyledActionCardBody = styled.div.withConfig({
  displayName: "AutomationBuilderCardStyles__StyledActionCardBody",
  componentId: "sc-1ejxrrh-5"
})(["flex:1;position:relative;overflow:hidden;padding:0 16px;background-image:linear-gradient( ", ",", " 50% ),linear-gradient(", ",", ");background-position:0 100%;background-repeat:no-repeat;background-size:100% ", "px,100% ", "px;background-attachment:local,scroll;"], ({
  $isDisabled
}) => rgba($isDisabled ? GYPSUM : OLAF, 0), ({
  $isDisabled
}) => rgba($isDisabled ? GYPSUM : OLAF, 1), rgba(KOALA, 0), rgba(KOALA, 1), CONTENT_OVERHANG_SIZE * 1.5, CONTENT_OVERHANG_SIZE);
export const StyledActionCardFooter = styled.div.withConfig({
  displayName: "AutomationBuilderCardStyles__StyledActionCardFooter",
  componentId: "sc-1ejxrrh-6"
})(["display:flex;align-items:center;justify-content:space-between;flex:none;height:37px;padding:0 12px;border-top:1px solid ", ";"], ({
  theme
}) => theme.color['do-not-use-battleship']);
export const StyledActionIcon = styled(ActionIcon).withConfig({
  displayName: "AutomationBuilderCardStyles__StyledActionIcon",
  componentId: "sc-1ejxrrh-7"
})(["flex:none;"]);
export const StyledActionTypeHeader = styled.div.withConfig({
  displayName: "AutomationBuilderCardStyles__StyledActionTypeHeader",
  componentId: "sc-1ejxrrh-8"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:center;flex:1;"]);
export const StyledStatusText = styled(Small).withConfig({
  displayName: "AutomationBuilderCardStyles__StyledStatusText",
  componentId: "sc-1ejxrrh-9"
})(["color:", ";"], ({
  theme
}) => theme.color['do-not-use-eerie']);

// Ghosted card styled exports
export const StyledGhostedActionCard = styled(withTransientStyleProps(UIClickable)).withConfig({
  displayName: "AutomationBuilderCardStyles__StyledGhostedActionCard",
  componentId: "sc-1ejxrrh-10"
})(["", " background-color:transparent;border-color:", ";position:relative;"], COMMON_CARD_STYLE, ({
  theme
}) => theme.color['do-not-use-slinky']);
export const StyledZoomedOutGhostedActionCard = styled(withTransientStyleProps(UIClickable)).withConfig({
  displayName: "AutomationBuilderCardStyles__StyledZoomedOutGhostedActionCard",
  componentId: "sc-1ejxrrh-11"
})(["", " background-color:transparent;border-color:", ";position:relative;justify-content:space-between;"], COMMON_CARD_STYLE, ({
  theme
}) => theme.color['do-not-use-slinky']);
export const StyledGhostedActionCardBody = styled.div.withConfig({
  displayName: "AutomationBuilderCardStyles__StyledGhostedActionCardBody",
  componentId: "sc-1ejxrrh-12"
})(["flex:1;position:relative;overflow:hidden;padding:0 16px;"]);
export const StyledGhostedActionCardFooter = styled.div.withConfig({
  displayName: "AutomationBuilderCardStyles__StyledGhostedActionCardFooter",
  componentId: "sc-1ejxrrh-13"
})(["display:flex;align-items:center;justify-content:space-between;flex:none;height:37px;padding:0 12px;"]);